import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { Autoplay, Controller, EffectFade, Navigation, Pagination, EffectCoverflow, Thumbs, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination, EffectCoverflow, Thumbs]) // Swiper宣言

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger)
//             ####     ####    ###    #####
//            ##       ##      ## ##   ##  ##
//  ########  ##  ###   ###   ##   ##  #####
//            ##   ##     ##  #######  ##
//             ####    ####   ##   ##  ##

// const strInterviewWrap = document.querySelector('.InterviewSingle__group-list')
// if (strInterviewWrap) {
//   setInterviewScroll()
// }

// function setInterviewScroll() {
//   const gsapMediaQuery = gsap.matchMedia() // GSAP用メディアクエリ
//   gsap.registerPlugin(ScrollTrigger) // スクロールトリガー起動

//   gsapMediaQuery.add('(min-width:769px)', () => {
//     const panels = gsap.utils.toArray('.panel')
//     const strSideScrollWrapWidth = strInterviewWrap.offsetWidth
//     const strSideScroll = gsap.to(panels, {
//       xPercent: -50 * (panels.length - 2), // transformX
//       ease: 'ease-out', // easingの設定
//       // markers: true,
//       scrollTrigger: {
//         start: 'top-=150', // 開始位置を調整
//         duration: 0.3,
//         trigger: strInterviewWrap, // アニメーションの対象となる要素
//         pin: true, // 要素を固定する
//         scrub: 1.2, // スクロールとアニメーションを同期させる。数値で秒数の設定に
//         // snap: {
//         //   // スナップスクロールにする
//         //   snapTo: 1 / (panels.length - 1), // スナップで移動させる位置
//         //   duration: { min: 0.1, max: 0.2 }, // スナップで移動する際の遅延時間
//         //   ease: 'none', // easing
//         // },
//         end: 'top+=2500', // アニメーションの終了タイミング
//       },
//     })
//   })
// }

if (document.querySelector('.InterviewSingle__group-Slide')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars

  const slideItem = document.querySelector('.InterviewSingle__group-Slide')

  const proSlideSwiper = new Swiper(slideItem, {
    // init: false, // 自動で初期化しない（proSlideSwiper.init()で初期化）
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: false, // ループ
    preloadImages: false, // スライド内の画像を読み終えてから開始
    slidesPerView: 1.2, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
    spaceBetween: 20, //スライド同士の間隔を空ける
    centeredSlides: true, // 中央のスライドを基準にする
    navigation: {
      nextEl: '.swiper-button-next', // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev', // 次のページボタンを呼び出す要素
    },
  })
}
